import { useEffect } from 'react';

import { HUB_MESSAGES } from '~/types/socket';

import { isBrowserCFD } from '../utils';
import { useSocket } from './socket/use-setup-socket';

export const useClearDisplayBeforeUnload = () => {
  const publish = useSocket();

  useEffect(() => {
    if (!isBrowserCFD) return;

    const clearSelectedDisplayOnRetail = () => {
      publish(HUB_MESSAGES.DEVICES, { selectedDisplay: {} });
    };

    window.addEventListener('beforeunload', clearSelectedDisplayOnRetail);

    return () => {
      window.removeEventListener('beforeunload', clearSelectedDisplayOnRetail);
    };
  }, [publish]);
};
